import { EmbeddedVideoCard } from "components/cards/EmbeddedVideoCard/EmbeddedVideoCard";
import { type EmbeddedVideoCardBaseProps } from "components/cards/EmbeddedVideoCard/types";
import React from "react";
import { type EmbeddedVideoOverview } from "../types/models";
import { EmbeddedVideosThreeDotsItemMenu } from "./EmbeddedVideosThreeDotsItemMenu";

export interface EmbeddedVideoOverviewCardProps extends EmbeddedVideoCardBaseProps<EmbeddedVideoOverview> {
  handleEdit: (id: number, isDraft: boolean) => void;
  handleDuplicate: (ids: number[]) => void;
  handleDelete: (ids: number[], flowsCount?: number, packsCount?: number) => void;
  handleToggleVisibility: (id: number[], hidden: boolean) => () => void;
  readonly?: boolean;
  hideDisabled?: boolean;
}

export const EmbeddedVideoOverviewCard = (props: EmbeddedVideoOverviewCardProps): React.ReactElement => {
  const { item, selected, onSelect, readonly, disabled, hideDisabled, ...popupMenuProps } = props;
  return (
    <EmbeddedVideoCard
      item={item}
      disabled={disabled}
      url={props.item.id.toString()}
      onSelect={onSelect}
      popupMenu={
        <EmbeddedVideosThreeDotsItemMenu
          {...popupMenuProps}
          circle
          item={item}
          outlinedEllipsis
          readonly={readonly}
          isChecked={selected}
          hideDisabled={hideDisabled}
        />
      }
      selected={selected}
    />
  );
};
